import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { X, Check, Shield } from "lucide-react";
import styles from "./SubscriptionPlansPage.module.css";
import {
  PLANS,
  CREDITS_MAP,
  PlanData,
  proceedToCCBillSubscription,
} from "../../services/membershipCheckout";
import { setUser } from "../../redux/modules/userSlice";

export const PinkCheckIcon = () => (
  <svg
    className={styles.checkIcon}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.875 10C1.875 5.5125 5.5125 1.875 10 1.875C14.4875 1.875 18.125 5.5125 18.125 10C18.125 14.4875 14.4875 18.125 10 18.125C5.5125 18.125 1.875 14.4875 1.875 10ZM13.1442 7.24333C13.0776 7.19517 13.0022 7.1606 12.9223 7.14162C12.8423 7.12263 12.7594 7.11958 12.6783 7.13266C12.5972 7.14574 12.5194 7.17469 12.4495 7.21785C12.3796 7.261 12.3189 7.31752 12.2708 7.38417L9.27333 11.535C9.25497 11.5604 9.23111 11.5814 9.20353 11.5963C9.17595 11.6112 9.14536 11.6197 9.11404 11.6211C9.08271 11.6226 9.05147 11.6169 9.02264 11.6046C8.9938 11.5923 8.96812 11.5736 8.9475 11.55L7.6925 10.1167C7.63914 10.0527 7.57354 10.0001 7.49955 9.96185C7.42556 9.92361 7.34467 9.90055 7.26164 9.89402C7.17861 9.88749 7.09511 9.89762 7.01605 9.92381C6.93699 9.95001 6.86397 9.99174 6.80126 10.0466C6.73856 10.1014 6.68745 10.1682 6.65092 10.243C6.6144 10.3179 6.59321 10.3993 6.58859 10.4824C6.58396 10.5656 6.59601 10.6488 6.62402 10.7273C6.65202 10.8057 6.69542 10.8777 6.75167 10.9392L8.00667 12.3733C8.15112 12.5384 8.33096 12.6688 8.53279 12.7548C8.73462 12.8408 8.95325 12.8801 9.17239 12.8698C9.39153 12.8596 9.60553 12.8 9.79846 12.6956C9.99138 12.5912 10.1583 12.4445 10.2867 12.2667L13.2842 8.11667C13.3324 8.05015 13.367 7.97478 13.386 7.89488C13.4051 7.81497 13.4082 7.73209 13.3952 7.65098C13.3822 7.56986 13.3533 7.49211 13.3103 7.42216C13.2672 7.35222 13.2107 7.29145 13.1442 7.24333Z"
      fill="#FD3C84"
    />
  </svg>
);

export const CreditCoinIcon = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={styles.coinSvg}
  >
    <g filter="url(#filter0_f_plan_coins)">
      <path
        d="M13 15.5V26.5C13 27.88 15.239 29 18 29C19.126 29 20.164 28.814 21 28.5M21 28.5V20.5M21 28.5C21 29.88 23.239 31 26 31C28.761 31 31 29.88 31 28.5V20.5M23 18.5V15.5"
        stroke="url(#paint0_linear_plan_coins)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 18C15.239 18 13 16.88 13 15.5C13 14.12 15.239 13 18 13C20.761 13 23 14.12 23 15.5C23 16.88 20.761 18 18 18Z"
        stroke="url(#paint1_linear_plan_coins)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 24.5C21 25.88 23.239 27 26 27C28.761 27 31 25.88 31 24.5M13 19.5C13 20.88 15.239 22 18 22C19.126 22 20.165 21.814 21 21.5M13 23C13 24.38 15.239 25.5 18 25.5C19.126 25.5 20.164 25.314 21 25M26 23C23.239 23 21 21.88 21 20.5C21 19.12 23.239 18 26 18C28.761 18 31 19.12 31 20.5C31 21.88 28.761 23 26 23Z"
        stroke="url(#paint2_linear_plan_coins)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M13 15.5V26.5C13 27.88 15.239 29 18 29C19.126 29 20.164 28.814 21 28.5M21 28.5V20.5M21 28.5C21 29.88 23.239 31 26 31C28.761 31 31 29.88 31 28.5V20.5M23 18.5V15.5"
      stroke="url(#paint3_linear_plan_coins)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 18C15.239 18 13 16.88 13 15.5C13 14.12 15.239 13 18 13C20.761 13 23 14.12 23 15.5C23 16.88 20.761 18 18 18Z"
      stroke="url(#paint4_linear_plan_coins)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 24.5C21 25.88 23.239 27 26 27C28.761 27 31 25.88 31 24.5M13 19.5C13 20.88 15.239 22 18 22C19.126 22 20.165 21.814 21 21.5M13 23C13 24.38 15.239 25.5 18 25.5C19.126 25.5 20.164 25.314 21 25M26 23C23.239 23 21 21.88 21 20.5C21 19.12 23.239 18 26 18C28.761 18 31 19.12 31 20.5C31 21.88 28.761 23 26 23Z"
      stroke="url(#paint5_linear_plan_coins)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <filter
        id="filter0_f_plan_coins"
        x="-10"
        y="-10"
        width="64"
        height="64"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="10" result="effect1_foregroundBlur_plan_coins" />
      </filter>
      <linearGradient
        id="paint0_linear_plan_coins"
        x1="13"
        y1="23.25"
        x2="31"
        y2="23.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FECD3D" />
        <stop offset="0.39873" stopColor="#FFD761" />
        <stop offset="1" stopColor="#F1A21F" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_plan_coins"
        x1="13"
        y1="15.5"
        x2="23"
        y2="15.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FECD3D" />
        <stop offset="0.39873" stopColor="#FFD761" />
        <stop offset="1" stopColor="#F1A21F" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_plan_coins"
        x1="13"
        y1="22.5"
        x2="31"
        y2="22.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FECD3D" />
        <stop offset="0.39873" stopColor="#FFD761" />
        <stop offset="1" stopColor="#F1A21F" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_plan_coins"
        x1="13"
        y1="23.25"
        x2="31"
        y2="23.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FECD3D" />
        <stop offset="0.39873" stopColor="#FFD761" />
        <stop offset="1" stopColor="#F1A21F" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_plan_coins"
        x1="13"
        y1="15.5"
        x2="23"
        y2="15.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FECD3D" />
        <stop offset="0.39873" stopColor="#FFD761" />
        <stop offset="1" stopColor="#F1A21F" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_plan_coins"
        x1="13"
        y1="22.5"
        x2="31"
        y2="22.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FECD3D" />
        <stop offset="0.39873" stopColor="#FFD761" />
        <stop offset="1" stopColor="#F1A21F" />
      </linearGradient>
    </defs>
  </svg>
);

export default function SubscriptionPlansPage() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const reduxUser = useSelector((state: any) => state.user?.currentUser);
  const storedUserRaw = typeof window !== "undefined" ? localStorage.getItem("user") : null;
  const currentUser = reduxUser || (storedUserRaw ? JSON.parse(storedUserRaw) : null);
  const isAuthenticated = Boolean(
    currentUser && (currentUser._id || currentUser.id || currentUser.email)
  );

  const [selectedPlan, setSelectedPlan] = useState<PlanData | null>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [successPlan, setSuccessPlan] = useState<PlanData | null>(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  // Check URL return parameters on mount (payment=success, payment=failed, etc.)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const paymentStatus = params.get("payment");
    const tierId = params.get("tier");

    if (paymentStatus === "success" && tierId) {
      const matched = PLANS.find((p) => p.id === tierId) || null;
      setSuccessPlan(matched);
      setShowSuccessModal(true);

      // Update local storage and Redux with newly active membership tier
      try {
        const stored = localStorage.getItem("user");
        if (stored) {
          const u = JSON.parse(stored);
          const updated = { ...u, tier: tierId };
          localStorage.setItem("user", JSON.stringify(updated));
          dispatch(setUser(updated));
        }
      } catch (err) {
        console.warn("Could not update local user tier after subscription success:", err);
      }

      // Clean up URL query parameters without full page reload
      history.replace(location.pathname);
    }
  }, [location.search, location.pathname, history, dispatch]);

  const handleScroll = () => {
    if (containerRef.current) {
      const scrollLeft = containerRef.current.scrollLeft;
      const cardWidth = containerRef.current.children[0]?.getBoundingClientRect().width || 306;
      const gap = 30;
      const index = Math.round(scrollLeft / (cardWidth + gap));
      setActiveIndex(Math.max(0, Math.min(index, PLANS.length - 1)));
    }
  };

  const handleDotClick = (index: number) => {
    setActiveIndex(index);
    if (containerRef.current) {
      const cardWidth = containerRef.current.children[0]?.getBoundingClientRect().width || 306;
      const gap = 30;
      containerRef.current.scrollTo({
        left: index * (cardWidth + gap),
        behavior: "smooth",
      });
    }
  };

  const handleCheckout = async (plan: PlanData) => {
    if (isRedirecting) return;
    setIsRedirecting(true);
    try {
      await proceedToCCBillSubscription(plan, { dispatch });
    } catch (err) {
      console.error("Checkout failed:", err);
      setIsRedirecting(false);
    }
  };

  return (
    <div className={styles.pageContainer}>
      <h1 className={styles.formTitle}>Choose a Plan</h1>

      <div className={styles.plansGrid} ref={containerRef} onScroll={handleScroll}>
        {PLANS.map((plan) => {
          const {
            id,
            name,
            tagline,
            taglineColor,
            description,
            price,
            period,
            buttonText,
            iconPath,
            isPopular,
            popularBadgeText,
            inheritedHeading,
            includedFeatures,
            creditsText,
            creditsValueText,
          } = plan;

          return (
            <div
              key={id}
              className={`${styles.planCard} ${isPopular ? styles.planCardRecommended : ""
                } ${id === "platinum" ? styles.planCardPlatinum : ""}`}
            >
              {isPopular && popularBadgeText && (
                <div className={styles.recommendedBadge}>{popularBadgeText}</div>
              )}

              {/* Card Header: Icon + Title & Tagline */}
              <div className={styles.cardHeader}>
                <div className={styles.iconContainer}>
                  <img src={iconPath} alt={`${name} Icon`} className={styles.planIconImage} />
                </div>
                <div className={styles.titleInfo}>
                  <h3 className={styles.planName}>{name}</h3>
                  <span
                    className={
                      taglineColor === "pink" ? styles.planTaglinePink : styles.planTaglineGrey
                    }
                  >
                    {tagline}
                  </span>
                </div>
              </div>

              {/* Description */}
              <p className={styles.planDescription}>{description}</p>

              {/* Price & Billing Cycle */}
              <div className={styles.priceContainer}>
                <span className={styles.price}>{price}</span>
                <span className={styles.period}>{period}</span>
              </div>

              {/* CTA Button */}
              <button
                type="button"
                className={isPopular ? styles.chooseBtnRecommended : styles.chooseBtn}
                onClick={() => setSelectedPlan(plan)}
              >
                {buttonText}
              </button>

              {/* What's Included Section Divider */}
              <div className={styles.sectionHeader}>
                <span className={styles.sectionTitle}>What's Included</span>
                <div className={styles.dashedDivider} />
              </div>

              {/* Inherited Benefits Heading (if any) */}
              <div className={styles.includedSection}>
                {inheritedHeading && (
                  <div className={styles.inheritedHeadingText}>{inheritedHeading}</div>
                )}
                <div className={styles.featuresList}>
                  {includedFeatures.map((feat, idx) => (
                    <div key={idx} className={styles.featureItem}>
                      <PinkCheckIcon />
                      <span className={styles.featureText}>{feat}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Bottom Inset: Monthly Credits */}
              <div className={styles.creditsBox}>
                <div className={styles.coinIconCircle}>
                  <CreditCoinIcon />
                </div>
                <div className={styles.creditsText}>
                  <span className={styles.creditsTitle}>{creditsText}</span>
                  <span className={styles.creditsSubtitle}>{creditsValueText}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Mobile/Tablet Dots Indicator */}
      <div className={styles.dotsContainer}>
        {PLANS.map((_, index) => (
          <button
            key={index}
            type="button"
            className={`${styles.dot} ${index === activeIndex ? styles.activeDot : ""}`}
            onClick={() => handleDotClick(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      {/* CCBill Payment Modal */}
      {selectedPlan && (
        <div className={styles.modalOverlay} onClick={() => !isRedirecting && setSelectedPlan(null)}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <button
              className={styles.closeBtn}
              onClick={() => !isRedirecting && setSelectedPlan(null)}
              aria-label="Close modal"
            >
              <X size={20} color="#ffffff" />
            </button>

            <div className={styles.modalHeader}>
              <div className={styles.modalIconContainer}>
                <img
                  src={selectedPlan.iconPath}
                  alt={`${selectedPlan.name} Icon`}
                  className={styles.modalIconImageLarge}
                />
              </div>
              <h2 className={styles.modalTitle}>Secure Subscription Payment</h2>
              <p className={styles.modalSubtitle}>
                Subscribe to {selectedPlan.name} for {selectedPlan.price} per month
              </p>
            </div>

            <div className={styles.modalDetails}>
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>Your purchase:</span>
                <span className={styles.detailValue}>{selectedPlan.name}</span>
              </div>
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>Included Credits:</span>
                <span className={styles.detailValue}>{CREDITS_MAP[selectedPlan.id] || 0}</span>
              </div>
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>Billing Interval:</span>
                <span className={styles.detailValue}>Every 30 days (cancel anytime)</span>
              </div>
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>Total:</span>
                <span className={styles.detailValue}>{selectedPlan.price}</span>
              </div>
            </div>

            {!isAuthenticated ? (
              <div className={styles.authNotice}>
                <p className={styles.authNoticeText}>
                  Please sign in or create an account so your subscription and monthly credits are linked directly to your profile.
                </p>
                <div className={styles.authActions}>
                  <button
                    type="button"
                    className={styles.authLoginBtn}
                    onClick={() => history.push(`/login?returnTo=/subscription-plans`)}
                  >
                    Sign In
                  </button>
                  <button
                    type="button"
                    className={styles.authRegisterBtn}
                    onClick={() => history.push(`/register?returnTo=/subscription-plans`)}
                  >
                    Create Account
                  </button>
                </div>
              </div>
            ) : (
              <>
                <button
                  type="button"
                  className={styles.payBtn}
                  disabled={isRedirecting}
                  onClick={() => handleCheckout(selectedPlan)}
                >
                  <span className={styles.ccBillLogo}>ccBill</span>{" "}
                  {isRedirecting ? "Redirecting to Secure CCBill Checkout..." : "Pay With CCBill"}
                </button>
                <div className={styles.securityNotice}>
                  <Shield size={14} color="#FD3C84" />
                  <span>256-bit SSL encrypted • Discreet Billing • CCBill Protected</span>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* Subscription Success Modal */}
      {showSuccessModal && (
        <div className={styles.modalOverlay} onClick={() => setShowSuccessModal(false)}>
          <div className={styles.successModalContent} onClick={(e) => e.stopPropagation()}>
            <button
              className={styles.closeBtn}
              onClick={() => setShowSuccessModal(false)}
              aria-label="Close modal"
            >
              <X size={20} color="#ffffff" />
            </button>

            <div className={styles.successIconCircle}>
              <Check size={36} strokeWidth={2.5} />
            </div>

            <h2 className={styles.successTitle}>Subscription Activated!</h2>
            <p className={styles.successSubtitle}>
              Congratulations! Your {successPlan?.name || "membership"} plan is now active.
            </p>

            {successPlan && (
              <div className={styles.successPerksBox}>
                <div className={styles.successPerkTitle}>Your Plan Perks</div>
                <div className={styles.successPerkItem}>
                  <PinkCheckIcon />
                  <span>{successPlan.creditsText} ({successPlan.creditsValueText})</span>
                </div>
                {successPlan.includedFeatures.slice(0, 3).map((f, i) => (
                  <div key={i} className={styles.successPerkItem}>
                    <PinkCheckIcon />
                    <span>{f}</span>
                  </div>
                ))}
              </div>
            )}

            <button
              type="button"
              className={styles.successDoneBtn}
              onClick={() => {
                setShowSuccessModal(false);
                history.push("/");
              }}
            >
              Explore SugarCribs
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
